import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
import AudioBox from './components/audio/audiobox';
import Pagination from './components/pagination/pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';

import './css/previoussets.css';

export default class PreviousSets extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			sets: {},
			name: '',
			page: 0,
			filter: 'Recent',
			pagination: {},
			genre: -1,
			genres: [],
			genrelist: [],
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleChange1 = this.handleChange1.bind(this);
		this.handleFilter = this.handleFilter.bind(this);
		this.pageSearch = this.pageSearch.bind(this);
  };

  
  
  async componentDidMount() {
		document.title = "Previous Sets | Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		const params = new URLSearchParams();
    const x = await postApi('/api/v2/previousgenres', params);
		this.setState({genres: x.data});

		this.DoSearchSets();
	}

	componentWillUnmount() {
		clearTimeout(this.timeout);
	}

	handleChange(event) {
		clearTimeout(this.timeout);
		let genre = this.state.genrelist;
		if( event.target.name!=='name') {
			if(event.target.checked) {
				genre.push(event.target.name);
			} else {
				let index = genre.indexOf(event.target.name)
				genre.splice(index,1);
			}
		}
		this.setState({genrelist: genre});
		this.timeout = setTimeout(() => {this.DoSearchSets()}, 2000);
	}
	handleChange1(event) {
		event.preventDefault();
		clearTimeout(this.timeout);
		this.DoSearchSets();
	}

	handleFilter(filter) {
		this.setState({filter},()=>{this.DoSearchSets()});
	}

	pageSearch = async(e) => {
    //---- Pagination
    var page = 0;
    if( e.target ) if( e.target.id ) page = e.target.id;
    this.setState({page}, () => {
      this.DoSearchSets(e);
    });
  }

	DoSearchSets = async (e) =>{
    this.setState( { sets: '' } );

    const params = new URLSearchParams();

		
    
		//---- Page
    if( parseInt( this.state.page ) > 0 ) params.append('page', this.state.page );

		//---- Filter
    params.append('filter', this.state.filter );
		params.append('genre', this.state.genrelist);

		//---- Name
		let name = document.getElementById('name');
		params.append( 'name', name?name.value:'' );
    
    const x = await postApi('/api/v2/previous', params);
    if( x.status === 200 ) {
      this.setState({sets: x.data.published, pagination: x.data.Pagination, status: true});
    }
  }
	
	selectGenre(id) {
		if( id === this.state.genre ) {
			this.setState({genre: -1, genrelist: []});
		} else {
			this.setState({genre: id, genrelist: []});
		}
	}

	render() {
		const previous = 
      Object.keys(this.state.sets).map((e,i) => {
        return (
					<Col md={4} key={i}>
						<AudioBox audio={this.state.sets[e]} />
					</Col>
        )
      })
		const genres = 
      Object.keys(this.state.genres).map((e,i) => {
        return (
					<li key={i}>
						<div className="previousset-li" onClick={(e)=>this.selectGenre(i)}>
							
							<span>{e}</span>
							<div className="text-right"><FontAwesomeIcon icon="caret-down" className={`previousset-caret-${this.state.genre===i?'down':'right'}`} /></div>
							
							
							{/*<div style={{position: 'absolute', bottom: this.state.genre===i?0:6, right: 10, fontWeight: 800}}>{this.state.genre===i?<>&#8963;</>:<>&#8964;</>}</div>*/}
						</div>
						
						{this.state.genre===i&&
							<ul>
								{this.state.genres[e].map((f,j) => {
									return (
										<li key={j}>
											<label htmlFor={`genre['${this.state.genres[e][j][0]}']`} style={{fontWeight: 200}}>{this.state.genres[e][j][0]}
												<div className="float-right">
													<input type="checkbox" name={this.state.genres[e][j][0]} id={`genre['${this.state.genres[e][j][0]}']`} onChange={(e)=>this.handleChange(e)} />
												</div>
											</label>
											<br />
										</li>
									)
								})}
							</ul> 
						}
					</li>
        )
      })
		return (
			<>
				{this.state.status &&
					<>
						<div className="live">
							<div className="live-background"></div>
						</div>


						<div className="article">
							<Row className="gx-0 pb-5">
								<Col className="live-header">
									<h3>Catch up on previous sets by your favourite DJ</h3>
								</Col>
								
							</Row>
							
							<Row>
								<Col xs lg={2} className="toolbar py-2">
									<Form className="" id="contact-form" onSubmit={(e)=>this.handleChange1(e)}>
										<small>Search</small>
										<InputGroup className="pb-3" style={{paddingBottom: '0px'}}>
											<FormControl type="text" name="name" id="name" onChange={(e)=>this.handleChange(e)}  placeholder="Search Name / Genre" aria-label="Name" aria-describedby="basic-addon1" required style={{padding: '5px 10px'}} />
										</InputGroup>

										<small>Search Type</small>
										<ul className="previousset-collapsible">
											<li onClick={()=>this.handleFilter("Recent")}>
												<div className="previousset-li" onClick={(e)=>this.selectGenre("")}>
													Recent
													<span className="float-right"><Form.Check type={"radio"} id="Recent" name="filter" checked={this.state.filter==="Recent"?true:false} /></span>
												</div>
											</li>
											<li onClick={()=>this.handleFilter("Popular")}>
												<div className="previousset-li" onClick={(e)=>this.selectGenre("")}>
													Popular
													<span className="float-right"><Form.Check type={"radio"} id="Popular" name="filter" checked={this.state.filter==="Popular"?true:false} /></span>
												</div>
											</li>
											{/*<li onClick={()=>this.handleFilter("Comments")}>
												<div className="previousset-li" onClick={(e)=>this.selectGenre("")}>
													Comments
													<span className="float-right"><Form.Check type={"radio"} id="Comments" name="filter" checked={this.state.filter==="Comments"?true:false} /></span>
												</div>
											</li>*/}
											<li onClick={()=>this.handleFilter("Favourite")}>
												<div className="previousset-li" onClick={(e)=>this.selectGenre("")}>
													Favourites
													<span className="float-right"><Form.Check type={"radio"} id="Favourites" name="filter" checked={this.state.filter==="Favourite"?true:false} /></span>
												</div>
											</li>
											<li onClick={()=>this.handleFilter("Liked")}>
												<div className="previousset-li" onClick={(e)=>this.selectGenre("")}>
													Likes
													<span className="float-right"><Form.Check type={"radio"} id="Likes" name="filter" checked={this.state.filter==="Liked"?true:false} /></span>
												</div>
											</li>
										</ul>
										<small>Search Genres</small>
										<ul className="previousset-collapsible">
											{genres}
										</ul>
									</Form>
								</Col>
								<Col>
									<Row>
										<Col>
											<Pagination pagination={this.state.pagination} function={this.pageSearch} />
										</Col>
									</Row>
									<Row className="h-100">
										{previous}
									</Row>
								</Col>
							</Row>
						</div>
					</>
				}
			</>
		);
	}
}
